/*$(function() {
    var nav_pos = $(".page-nav").offset().top;
var nav_height = $(".page-nav").outerHeight();
$(window).scroll(function () {
    if ($(this).scrollTop() > nav_pos) {
        $("body").css("padding-top", nav_height);
        $(".page-nav").addClass("is-fixed");
    } else {
        $("body").css("padding-top", 0);
        $(".page-nav").removeClass("is-fixed");
    }
});
});*/

  /*スクロールで表示*/
/*$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 300) {
   $('.follow-area').fadeIn(400);
   } else {
    $('.follow-area').fadeOut(400);
  }
  });*/

$(function(){
  var swiper = new Swiper('.swiper-container01', {
    navigation: { 
      nextEl: '.swiper-button-next01',
      prevEl: '.swiper-button-prev01',
    },
    pagination: {
    el: '.swiper-pagination01',
    clickable: true,
  },
    loop: true,
    observer: true,
		observeParents: true,
    /*speed: 5000,*/ // ループの時間
    /*allowTouchMove: false,*/ // スワイプ無効
  /*autoplay: {*/
    /*delay: 0,*/ // 途切れなくループ
  /*},*/
    /*disabledClass: '.swiper-button-disabled',*/
    slidesPerView: 1, // 一度に表示する枚数
    /*centeredSlides: true, */// アクティブなスライドを中央にする
		spaceBetween: 20,
		breakpoints: {
			// 768px以上の場合
			768: {
				/*slidesPerView: 2,*/
        slidesPerView: 3,
				spaceBetween: 60,
			}
		}
	});
  });









